import React, { useState, useEffect } from 'react';
import { ChevronUpIcon, Square3Stack3DIcon } from '@heroicons/react/24/outline';
import LayersPanel from './LayersPanel';

export default function LeftControlPanel({
  selectedElement,
  elements,
  onSelectElement,
  onReorderElements,
}) {
  const [showLayers, setShowLayers] = useState(() => {
    // Load from localStorage on initial mount
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('sbw-layers-panel-open');
      return saved !== null ? JSON.parse(saved) : true;
    }
    return true;
  });

  // Save to localStorage whenever showLayers changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('sbw-layers-panel-open', JSON.stringify(showLayers));
    }
  }, [showLayers]);

  return (
    <div 
      className={`fixed bottom-4 left-4 z-50 bg-white border border-gray-200 rounded-lg overflow-hidden transition-shadow ${
        showLayers ? 'shadow-lg' : 'shadow-2xl'
      }`}
      data-layers-panel="true"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      {/* Toggle Header */}
      <button
        onClick={() => setShowLayers(!showLayers)}
        className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 border-b border-gray-200 transition-colors"
      >
        <div className="flex items-center gap-2">
          <Square3Stack3DIcon className="h-4 w-4 text-gray-700" />
          <h3 className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Layers</h3>
        </div>
        <ChevronUpIcon 
          className={`h-4 w-4 text-gray-600 transition-transform ${showLayers ? 'rotate-180' : ''}`}
        />
      </button>

      {/* Layers Content */}
      {showLayers && (
        <div className="p-4 max-h-[calc(100vh-80px)] overflow-y-auto w-90">
          <LayersPanel
            elements={elements}
            selectedElement={selectedElement}
            onSelectElement={onSelectElement}
            onReorderElements={onReorderElements}
          />
        </div>
      )}
    </div>
  );
}
